import type { SVGProps } from "react";

/**
 * clapperboard
 * @category Photography & Video
 */
export default function IconClapperboard(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M2.75 9.75H21.25M2.75 9.75V17.25C2.75 18.3546 3.64543 19.25 4.75 19.25H19.25C20.3546 19.25 21.25 18.3546 21.25 17.25V9.75M2.75 9.75V6.75C2.75 5.64543 3.64543 4.75 4.75 4.75H19.25C20.3546 4.75 21.25 5.64543 21.25 6.75V9.75M12.45 5L11.55 9.5M17.1875 5L16.0625 9.5M7.95 5L7.05 9.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
